var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMember && _vm.isPremium)?_c('Lock',{staticClass:"ml-1",staticStyle:{"height":"0.8rem"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }